import React from 'react';

import { cssMap } from '@compiled/react';

import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { parseDynamicLayoutOutputToJson } from './dynamic-layout-parser/dynamic-layout-parser';
import { DynamicLayoutSections } from './ui/section/dynamic-layout-sections';

export type DynamicLayoutData = {
	data: string;
	fastAnswerData?: string;
};

interface DynamicLayoutBodyProps {
	contentToRender: string;
}

const styles = cssMap({
	containerStyles: {
		textAlign: 'left',
	},
});

export const DynamicLayout = ({ contentToRender }: DynamicLayoutBodyProps): React.JSX.Element => {
	const parsedAnswer = parseDynamicLayoutOutputToJson(contentToRender);

	return (
		<SmartCardProvider>
			<Box xcss={styles.containerStyles} testId="dynamic-layout-container">
				<Stack space="space.300">
					{parsedAnswer &&
						parsedAnswer.length &&
						parsedAnswer.map((section, index) => (
							<DynamicLayoutSections key={index} section={section} />
						))}
				</Stack>
			</Box>
		</SmartCardProvider>
	);
};
